import ajax from './http'

const homeServer = {
  // 请求首页banner
  bannerPoster () {
    return ajax({
      url: '/showCore/appShowList',
      type: 'get',
    })
  },
  // 请求栏目数据
  getColumnData (){
    return ajax({
      url: '/bannerColum/getGoodsByBannerColum',
      type: 'get',
    })
  },
  // 全局搜索
  searchProduction(param) {
    return ajax({
      url: '/commodity/searchCommondity',
      type: 'get',
      params: param
    })
  }
}

export default homeServer
